import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

const isProd = process.env.NODE_ENV === 'production'

export default function (app) {
  Vue.use(VueAnalytics, {
    id: 'UA-151353630-1',
    router: app.router,
    autoTracking: {
      exception: true
    },
    debug: {
      enabled: !isProd,
      sendHitTask: isProd
    }
  })
}
